import "./_loader.scss";

function Loader(): JSX.Element {
  return (
    <div className="loader">
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
    </div>
  );
}

export default Loader;
